/**
 * Copied source from https://github.com/jaq316/leaflet-header,
 * because the leaflet does not natively support adding headers to a tile layer.
 * See discussion on leaflet github: https://github.com/Leaflet/Leaflet/issues/7560
 */

import L, { TileLayerOptions, Util } from 'leaflet';

export class TileLayerWithHeaders extends L.TileLayer {
  private _abortControllers: { [key: string]: AbortController } = {};

  constructor(
    url: string,
    private headers: { [header: string]: string },
    options?: TileLayerOptions,
  ) {
    super(url, options);
  }

  protected override createTile(coords: L.Coords, done: L.DoneCallback): HTMLElement {
    const img = document.createElement('img');
    img.setAttribute('role', 'presentation');

    const abortController = new AbortController();
    const abortSignal = abortController.signal;
    const key = this._tileCoordsToKey(coords);
    this._abortControllers[key] = abortController;

    const url = this.getTileUrl(coords);
    fetch(url, {
      headers: this.headers,
      signal: abortSignal,
    })
      .then((response) => response.blob())
      .then((blob) => {
        const objUrl = URL.createObjectURL(blob);
        img.onload = () => URL.revokeObjectURL(objUrl);
        img.src = objUrl;
        done(undefined, img); // Notify Leaflet that the tile is loaded
      })
      .catch((error) => {
        if (abortSignal.aborted) return;

        done(error, img); // Notify Leaflet of the error
      });

    return img;
  }

  // This method is not exposed by leaflet type definition, but exists on GridLayer
  private _removeTile(key: string) {
    const tile = this._tiles[key];
    if (!tile) return;

    // Cancel pending fetch associated with the tile
    this._abortControllers[key]?.abort('');

    tile.el.setAttribute('src', Util.emptyImageUrl);

    return (L.GridLayer.prototype as any)._removeTile.call(this, key);
  }
}
